import { INotification } from "@app/marketplace/core/models/response.model";
import { ICartData } from "../../shopping-cart/_models/cart.interface";

export const BASKET= {Key: 'basket'};
export interface State {
  data: ICartData;
  notification?:INotification;
  message?: string;
  success?: boolean;
  isLoading: boolean;
}
